export const getStartAndEndRecord = ({ pageNum, pageSize }) => {
  const startRecord = pageNum * pageSize;
  const endRecord = startRecord + pageSize - 1;

  return `${startRecord}-${endRecord}`;
};